// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea27c9db","453":"bebfe1b5","732":"d2cbfe69"}[chunkId] + ".chunk.js";
};